import { render, staticRenderFns } from "./InventoryNew.vue?vue&type=template&id=27b90e98"
import script from "./InventoryNew.vue?vue&type=script&lang=js"
export * from "./InventoryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports